import { Field } from "formik";
import React, { useCallback } from "react";
import AsyncSelect from "react-select/async";
import StarIcon from "../../assets/icons/req-star";
import ErrorMsg from "./error-msg";
import { useDispatch } from "react-redux";
import { debounce } from "lodash";

const SearchAddFeild = ({
  placeholder = "Type to search...",
  fetchData,
  name,
  defaultSelectClass = "selectField_border",
  label = "Phone Number",
  isLabelReq = true,
  field = "",
  value = { label: "" },
  onChange = () => {},
  isRequired = true,
  errorClass,
  isDisabled = false,
  searchRef,
  values,
  minWidth = "10rem",
  onFocus = () => {},
  dropdown = false,
  menuWidth = "100%",
  optionPadding = 7,
  menuPlacement = "auto",
  maxLength = 1000,
}) => {
  const dispatch = useDispatch();
  const customStyles = {
    indicatorSeparator: () => ({ display: "none" }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures dropdown is above everything

    menu: (provided, state) => ({
      ...provided,
      minWidth: menuWidth,
      zIndex: "9999",
      padding: 0, // Remove padding from the control
    }),
    control: (base, state) => ({
      ...base,
      margin: 0,

      color: "var(--create-table-row-fg-color)",
      fontWeight: "var(--create-table-row-font-weight)",
      fontSize: "var(--create-table-row-font-size)",
      borderRadius: "10px",
      width: "100%",
      backgroundColor: state.isDisabled ? "inherit" : base.backgroundColor,
      // ...(border
      //   ? {borderColor: state.isFocused ? "transparent" : "F51D00" }
      //   : { borderColor: state.isFocused ? "transparent" : "transparent" }),
      borderColor: state.isFocused ? "transparent" : "transparent",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        // Overwrittes the different states of border
        // borderColor: state.isFocused ? "#1D72DB" : "#F4F8FB",
      },
    }),
    option: (provided, state) => {
      return {
        ...provided,
        padding: optionPadding, // Remove padding from the options

        ...(state.data.color
          ? { color: state.data.color }
          : { color: "black" }),
        backgroundColor: state.isSelected
          ? "#e5ecffb2"
          : state.isFocused
          ? "#0000002E"
          : null,
        borderBottom: "1px solid #F5F5F5",
        fontFamily: "Inter, sans-serif",
        "&:hover": {
          backgroundColor: state.isFocused ? "#0000002E" : "#0000002E",
        },
        zIndex: "999",
      };
    },

    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: "var(--create-table-row-placeholder-color)",
        fontFamily: "Inter,sans-serif",
        fontWeight: "var(--create-table-row-font-weight)",
        fontSize: "var(--create-table-row-font-size)",
        opacity: "1",
        position: "absolute",
        whiteSpace: "wrap",
      };
    },
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#E5ECFF",
      // gap: "5px",
      // padding: "0px 6px",
    }),
    singleValue: (base, state) => ({
      ...base,
      // overflow: "visible",
      width: "100%",
      color: "var(--create-table-row-fg-color)",
      fontFamily: "Inter,sans-serif",
      fontWeight: "var(--create-table-row-font-weight)",
      fontSize: "var(--create-table-row-font-size)",
    }),
    dropdownIndicator: () => ({ display: dropdown ? "block" : "none" }),
    loadingIndicator: (base) => ({
      display: "none", // Hide the loading indicator
    }),
  };

  const handleKeyDown = (event) => {
    // Get current input value from the select component
    const currentInput = event.target.value || "";

    // Allow alphanumeric, space, and control keys
    const validKey = /^[a-zA-Z0-9\s]$/;
    const controlKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Tab",
      "Enter",
      "Escape",
    ];

    // Block special characters
    if (!validKey.test(event.key) && !controlKeys.includes(event.key)) {
      event.preventDefault();
      return;
    }

    // Block typing if maxLength is reached (but allow control keys)
    if (currentInput.length >= maxLength && validKey.test(event.key)) {
      event.preventDefault();
      return;
    }
  };

  const debouncedFetchData = useCallback(
    debounce((inputValue, callback) => {
      fetchData(inputValue, callback, field, values, dispatch);
    }, 500),
    [fetchData, field, values, dispatch]
  );

  return (
    <>
      <Field name={name}>
        {({ meta }) => {
          return (
            <>
              <div className="flex items-center w-full ">
                {isLabelReq && (
                  <label
                    style={{
                      minWidth: minWidth,
                    }}
                    className="whitespace-no-wrap flex text-sm"
                  >
                    {label}
                    <StarIcon />
                  </label>
                )}
                <AsyncSelect
                  // onKeyDown={(event) => {
                  //   if (event.key === "Enter") {
                  //     event.preventDefault();
                  //     event.stopPropagation();
                  //   }
                  // }}
                  onFocus={onFocus}
                  menuPlacement={menuPlacement} // Force dropdown to open upward
                  ref={(el) => {
                    if (searchRef) searchRef.current = el;
                  }}
                  isDisabled={isDisabled}
                  menuPortalTarget={document.body}
                  // {...(value?.label ? { value: value } : {})}
                  value={value}
                  className={`${defaultSelectClass}  selectField w-full h-full focus-within:ring-2 rounded focus-within:outline-none flex items-center focus-within:shadow-[0px_0px_0px_4px_#EBF2FF`}
                  styles={customStyles}
                  cacheOptions={false}
                  defaultOptions={false}
                  loadOptions={debouncedFetchData} // ✅ Use the debounced function
                  // loadOptions={(inputValue, callback) => {
                  //   fetchData(inputValue, callback, field, values, dispatch);
                  // }}
                  placeholder={placeholder}
                  loadingIndicator={false}
                  onChange={onChange}
                  onKeyDown={handleKeyDown} // Restrict special characters on keydown
                />
              </div>
              <div
                style={{
                  height: "1.5rem",
                }}
                className={`text-right w-full fs_12 ${errorClass}`}
              >
                {isRequired && <ErrorMsg name={name} />}
              </div>
            </>
          );
        }}
      </Field>
    </>
  );
};

export default SearchAddFeild;

// import { Field, useFormikContext } from "formik";
// import React, { useCallback, useEffect, useRef, useState } from "react";
// import AsyncSelect from "react-select/async";
// import StarIcon from "../../assets/icons/req-star";
// import ErrorMsg from "./error-msg";
// import { useDispatch } from "react-redux";
// import { debounce } from "lodash";
// import CloseIcon from "../../assets/icons/close-icon";
// import Select from "react-select";
// import axios from "axios";

// const SearchAddFeild = ({
//   placeholder = "Type to search...",
//   fetchData,
//   name,
//   defaultSelectClass = "selectField_border",
//   label = "Phone Number",
//   isLabelReq = true,
//   field = "",
//   value = { label: "" },
//   onChange = () => {},
//   isRequired = true,
//   errorClass,
//   isDisabled = false,
//   searchRef,
//   values,
//   minWidth = "10rem",
//   onFocus = () => {},
//   dropdown = false,
//   menuWidth = "100%",
//   optionPadding = 7,
//   menuPlacement = "auto",
//   defaultInputValue = false,
//   index,
// }) => {
//   const dispatch = useDispatch();

//   const { setFieldValue } = useFormikContext();
//   const customStyles = {
//     indicatorSeparator: () => ({ display: "none" }),
//     menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures dropdown is above everything

//     menu: (provided, state) => ({
//       ...provided,
//       minWidth: menuWidth,
//       zIndex: "9999",
//       padding: 0, // Remove padding from the control
//     }),
//     control: (base, state) => ({
//       ...base,
//       margin: 0,

//       color: "var(--secondary)",
//       fontFamily: "Poppins,sans-serif",
//       fontWeight: "400",
//       fontSize: "15px",
//       borderRadius: "10px",
//       width: "100%",
//       backgroundColor: state.isDisabled ? "inherit" : base.backgroundColor,
//       // ...(border
//       //   ? {borderColor: state.isFocused ? "transparent" : "F51D00" }
//       //   : { borderColor: state.isFocused ? "transparent" : "transparent" }),
//       borderColor: state.isFocused ? "transparent" : "transparent",
//       boxShadow: state.isFocused ? null : null,
//       "&:hover": {
//         // Overwrittes the different states of border
//         // borderColor: state.isFocused ? "#1D72DB" : "#F4F8FB",
//       },
//     }),
//     option: (provided, state) => {
//       return {
//         ...provided,
//         padding: optionPadding, // Remove padding from the options

//         ...(state.data.color
//           ? { color: state.data.color }
//           : { color: "black" }),
//         backgroundColor: state.isSelected
//           ? "#e5ecffb2"
//           : state.isFocused
//           ? "#0000002E"
//           : null,
//         borderBottom: "1px solid #F5F5F5",
//         fontFamily: "Inter, sans-serif",
//         "&:hover": {
//           backgroundColor: state.isFocused ? "#0000002E" : "#0000002E",
//         },
//         zIndex: "999",
//       };
//     },

//     placeholder: (defaultStyles) => {
//       return {
//         ...defaultStyles,
//         color: "#667085",
//         fontFamily: "Inter,sans-serif",
//         fontSize: "12px",
//         fontWeight: "400",
//         opacity: "1",
//         position: "absolute",
//         whiteSpace: "wrap",
//       };
//     },
//     multiValue: (base) => ({
//       ...base,
//       backgroundColor: "#E5ECFF",
//     }),
//     singleValue: (base, state) => ({
//       ...base,
//       fontWeight: "500",
//       width: "100%",
//       color: state.isDisabled ? "inherit" : "#464646",
//     }),
//     dropdownIndicator: () => ({ display: dropdown ? "block" : "none" }),
//     loadingIndicator: (base) => ({
//       display: "none", // Hide the loading indicator
//     }),
//   };
//   const [inputValue, setInputValue] = useState(value?.label || "");
//   const handleKeyDown = (event) => {
//     const validKey = /^[a-zA-Z0-9\s]+$/;
//     if (!validKey.test(event.key) && event.key !== "Backspace") {
//       event.preventDefault();
//     }
//   };

//   const debouncedFetchData = useCallback(
//     debounce((inputValue, callback) => {
//       fetchData(inputValue, callback, field, values, dispatch);
//     }, 500),
//     [fetchData, field, values, dispatch]
//   );

//   useEffect(() => {
//     setInputValue(value?.label);
//   }, [value]);

//   // console.log(inputValue, "dsfsfdsfsdfsfgfhfghfgsdfsfs");

//   console.log(inputValue, "dfsfdsfsdfsdfsdfs");

//   return (
//     <div>
//       <Field name={name}>
//         {({ meta }) => {
//           return (
//             <>
//               <div className="flex items-center w-full ">
//                 {isLabelReq && (
//                   <label
//                     style={{
//                       minWidth: minWidth,
//                     }}
//                     className="whitespace-no-wrap flex text-sm"
//                   >
//                     {label}
//                     <StarIcon />
//                   </label>
//                 )}
//                 <AsyncSelect
//                   value={value}
//                   // inputValue={inputValue}
//                   // {...(defaultInputValue ? { inputValue: inputValue } : {})}
//                   // onInputChange={(query, { action }) => {
//                   //   if (action === "input-change") {
//                   //     setInputValue(query);
//                   //     return query;
//                   //   }
//                   //   return inputValue;
//                   // }}
//                   // defaultInputValue={value?.label}
//                   // onBlur={(e) => {
//                   //   e.preventDefault();
//                   // }}
//                   onFocus={onFocus}
//                   menuPlacement={menuPlacement} // Force dropdown to open upward
//                   ref={(el) => {
//                     if (searchRef) searchRef.current = el;
//                   }}
//                   isDisabled={isDisabled}
//                   menuPortalTarget={document.body}
//                   // {...(value?.label ? { value: value } : {})}
//                   className={`${defaultSelectClass}  selectField w-full h-full focus-within:ring-2 rounded focus-within:outline-none flex items-center focus-within:shadow-[0px_0px_0px_4px_#EBF2FF`}
//                   styles={customStyles}
//                   cacheOptions={false}
//                   defaultOptions={false}
//                   loadOptions={debouncedFetchData} //  Use the debounced function
//                   placeholder={placeholder}
//                   loadingIndicator={false}
//                   onChange={onChange}
//                   onKeyDown={handleKeyDown} // Restrict special characters on keydown
//                 />
//                 {/* <div
//                   onClick={() => {
//                     setFieldValue(`itemData[${index}].item_id`, "");
//                     setFieldValue(`itemData[${index}].item_name`, "");
//                     setInputValue("");

//                     // setFieldValue(
//                     //   `itemData[${index}].item_uom_id`,
//                     //   ""
//                     // );
//                     // setFieldValue(
//                     //   `itemData[${index}].item_uom`,
//                     //   ""
//                     // );
//                     // setFieldValue(
//                     //   `itemData[${index}].uom_dropdown`,
//                     //   []
//                     // );
//                   }}
//                   className="absolute cursor-pointer z-15 right-1 top-1/2 transform -translate-y-1/2"
//                 >
//                   {value?.label && <CloseIcon width={15} height={15} />}
//                 </div> */}
//               </div>
//               <div
//                 style={{
//                   height: "1.5rem",
//                 }}
//                 className={`text-right w-full fs_12 ${errorClass}`}
//               >
//                 {isRequired && <ErrorMsg name={name} />}
//               </div>
//             </>
//           );
//         }}
//       </Field>
//     </div>
//   );
// };

// export default SearchAddFeild;
